module.exports = __webpack_public_path__ + "static/media/DSCF0267-AEooiYgs.c1dcbc69.JPG";